export function getNavigatorPlatform(): string {
  return (navigator as any)?.userAgentData?.platform || navigator?.platform || 'unknown'
}

export function isPlatformApple(): boolean {
  return /Mac|iPad|iPhone|iPod/.test(getNavigatorPlatform())
}

export function isPlatformMobileIOS(): boolean {
  return /iPad|iPhone|iPod/.test(getNavigatorPlatform())
}

// We have some of these in our deps: grep isSafari -rl node_modules | grep -E '.js$' | xargs grep -Eo '.{10}isSafari.{10}'
// Sniffing is hard and some of their strategies don't work, it is easier to keep our own reference here and change it as needed
export function isSafariDesktop() {
  const checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent)
  const isSafariDesktop =
    checkSafari != null && checkSafari[1] !== 'Chrome' && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null
  return isSafariDesktop
}
